import {COVERGO_SAAS_DEV} from "../consts.js"

export const forte_dev = {
	"forte-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "forte_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}